export const getClientApiVersion = () => {
  return process?.env?.NEXT_PUBLIC_CLIENT__API_VERSION || "0";
};

export const API_VERSION_HEADER = "x-api-client-version";
